<template lang="html">
  <div class="bottomnav">
    <div class="bottomnav__section">
      <router-link to="/#" class="bottomnav__section__nav">
          <BookacoachIcon
            width="30px"
            height="30px"
            color="#7E7E7E"
          />
      </router-link>
      <router-link to="/studentprogressreport" class="bottomnav__section__nav">
        <StudydashIcon
          width="30px"
          height="30px"
          color="#7E7E7E"
        />
      </router-link>
      <router-link to="/sessions" class="bottomnav__section__nav">
        <SessionsIcon
          width="30px"
          height="30px"
          color="#7E7E7E"
        />
      </router-link>
      <router-link to="/#" class="bottomnav__section__nav">
        <TokensIcon
          width="30px"
          height="30px"
          color="#7E7E7E"
        />
      </router-link>
      <router-link to="/#" class="bottomnav__section__nav">
        <SimulatorIcon
          width="30px"
          height="30px"
          color="#7E7E7E"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import BookacoachIcon from '../../components/icons/BookacoachIcon'
import StudydashIcon from '../../components/icons/StudydashIcon'
import SessionsIcon from '../../components/icons/SessionsIcon'
import TokensIcon from '../../components/icons/TokensIcon'
import SimulatorIcon from '../../components/icons/SimulatorIcon'

export default {
  components: {
    BookacoachIcon,
    StudydashIcon,
    SessionsIcon,
    TokensIcon,
    SimulatorIcon
  },
}
</script>

<style lang="scss">
  @import './CoachBottomnav.scss';
</style>



// WEBPACK FOOTER //
// src/coach-components/CoachLayout/CoachBottomnav.vue